import { Injectable } from "@angular/core"
import { HttpClient } from "@angular/common/http"
import { Observable } from "rxjs"
import { Router, NavigationEnd } from "@angular/router"
import { filter } from "rxjs/operators"
import { AuthService } from "src/app/shared/security/auth.service"
import { environment } from "../../../environments/environment"
import { JwtTokenService } from "src/app/shared/security/jwt.service";
import { AppService } from "src/app/server/app.service";


@Injectable()
export class LoginService {

    lastUrl: string

    constructor(
        private appService: AppService,
        private http: HttpClient,
        private router: Router,
        private jwt: JwtTokenService
    ) {

        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((res: NavigationEnd) => {
                this.lastUrl = res.url
            })

    }

    login(formData: any): Observable<any> {
        const params = formData
        return this.http.post<any>(`${environment.api}/login`, params)
    }

    savePass(formData: any): Observable<any> {
        const params = formData
        return this.http.post<any>(`${environment.api}/login/savepass`, params)
    }

    resetPass(formData: any): Observable<any> {
        const params = formData
        return this.http.post<any>(`${environment.api}/login/reset`, params)
    }

    handleLogin(path: string = this.lastUrl) {
        this.router.navigate(["/login", btoa(path)])
    }

    handleLogout() {
        this.appService.session.passportid = 0
        this.appService.eventSession.emit(this.appService.session)
        this.jwt.removeToken()

    }




}
